import { render, staticRenderFns } from "./batch-storage-save.vue?vue&type=template&id=51915f8c"
import script from "./batch-storage-save.vue?vue&type=script&lang=js"
export * from "./batch-storage-save.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports